export default __webpack_public_path__ + "static/media/zero.79c2e117.png";